import { useShallow } from 'zustand/react/shallow';
import type { GlobalState } from '@/data-store/zustand/slices/globalSlice';
import { useAppStore } from '@/data-store/zustand/zustandStoreProvider';

const useGlobalStore = <T extends GlobalState, K extends keyof GlobalState>(
  ...items: K[]
): Pick<T, K> => {
  const selectedItems = useAppStore(
    useShallow((state) =>
      // biome-ignore lint/performance/noAccumulatingSpread: Automated migration to Biome
      items.reduce((acc, item) => ({ ...acc, [item]: state.global[item] }), {})
    )
  );
  return selectedItems as Pick<T, K>;
};

export const useGlobalActions = () =>
  useAppStore((state) => state.global.actions);

export default useGlobalStore;
